































import {Component, Prop, Vue} from 'vue-property-decorator'
import moment from "moment"
import gateway from '@/gateway'
import {FormSelect} from '@frontend/components/src/FormSelect'
import date from '@/directives/date'
import sanitizeHtml from 'sanitize-html'
import {apolloClient} from '../apollo'
import gql from 'graphql-tag'


@Component({
  components: {
    FormSelect
  },
  directives: {
    date,
  }
})
class AutocompleteArticle extends Vue {
  name: 'article-complete-article'

  options = []

  loading = false

  @Prop({ type: Boolean, required: false, default: false})
  disablePrivate: boolean

  @Prop({type: Object})
  value!: any

  @Prop({type: String, default: 'title'})
  displayProperty!: any

  @Prop({type: String, required: false, default: ''})
  originalTitle!: any

  @Prop({type: Function, required: false, default: undefined})
  disableCheck?: (opt: any) => boolean

  @Prop({type: Boolean, required: false, default: false})
  strip!: boolean

  get selectedArticle () {
    return this.value ? this.value : {
      title: this.originalTitle,
    }
  }

  isPublic(option) {
    return true
  }

  async changed (search) {
    this.loading = true
    const articles = await apolloClient.query({
      query: gql`query ($search: String!) {
        articles(search: $search) {
          value {
            id
            slug
            title
            image
            publishedAt
            summary
            channel {
              name
              badge
            }
            contentType {
              name
            }
            leadAnalyst {
              slug
              name
              channel {
                name
                slug
              }
              jobTitle
              picture {
                square
              }
            }
          }
        }
      }`,
      variables: {
        search,
      },
    })

    this.options = articles.data.articles.value.map((value) => {
      console.log(value)
      return {
        ...value,
        disabled: this.disableCheck !== undefined && this.disableCheck(value),
      }
    })

    this.loading = false
  }

  input (v) {
    if (this.strip) {
      v.teaserText = sanitizeHtml(v.teaserText, {
        allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
          'nl', 'li', 'abbr', 'hr', 'br', 'div',
          'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'img', 'picture', 'source', 'iframe'
        ],
        allowedAttributes: {
          a: [ 'href', 'name', 'target' ],
          img: [ 'src', 'alt', 'loading' ],
          picture: ['class'],
          source: ['srcset', 'media'],
          iframe: ['src', 'frameborder', 'width', 'style', 'loading'],
        },
        selfClosing: [ 'img', 'br', 'hr', 'source' ],
      })
    }
    this.$emit('input', v)
  }
}

export default AutocompleteArticle

